/* =========================================================================
   Voog — Signup forms + Klaviyo wiring (Pre-launch site)
   Add to theme.liquid, once, right before </body>:
     {{ 'vg-signup.js' | asset_url | script_tag }}

   ⚠️ EDIT THIS: paste your Klaviyo Public API Key (6-character Site ID,
   NOT a private key) below. Found in Klaviyo → Settings → API Keys.
   ========================================================================= */
window.VG_KLAVIYO_KEY = 'WXefZn';

(function () {
  var KLAVIYO_KEY = window.VG_KLAVIYO_KEY;
  var REVISION = '2026-04-15';
  var UTM_COOKIE = 'vg_utm';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  /* ---------- cookie helpers ---------- */
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /* ---------- capture UTMs + fbclid on page load, persist across pages ---------- */
  function captureUTMs() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var hasAny = false;
    UTM_KEYS.forEach(function (key) {
      var val = params.get(key);
      if (val) { found[key] = val; hasAny = true; }
    });
    if (hasAny) {
      setCookie(UTM_COOKIE, JSON.stringify(found), 30);
    }
  }
  function getStoredUTMs() {
    var raw = getCookie(UTM_COOKIE);
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  captureUTMs();

  /* ---------- email validation ---------- */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* ---------- Klaviyo: subscribe profile to a list ---------- */
  function klaviyoSubscribe(email, listId, properties) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_KEY);
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: properties.form_location || 'withvoog-prelaunch',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties
              },
              subscriptions: {
                email: { marketing: { consent: 'SUBSCRIBED' } }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: { 'revision': REVISION, 'content-type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* ---------- wire the 3 signup forms (hero / offer / final) ---------- */
  function initForms() {
    var forms = document.querySelectorAll('form[data-form]');
    forms.forEach(function (form) {
      var emailInput = form.querySelector('input[type="email"]');
      var honeypot = form.querySelector('input[name="company"]');
      var submitBtn = form.querySelector('button[type="submit"]');
      var formLocation = form.getAttribute('data-form');
      var listId = form.getAttribute('data-klaviyo-list');
      var originalBtnText = submitBtn ? submitBtn.textContent : '';

      /* inline error element, created once */
      var errorEl = document.createElement('p');
      errorEl.style.cssText = 'color:#A64458;font-size:13px;margin-top:8px;display:none;';
      form.appendChild(errorEl);

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.style.display = 'block';
      }
      function clearError() {
        errorEl.style.display = 'none';
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        /* honeypot: if filled, pretend success and stop — bot traffic */
        if (honeypot && honeypot.value) {
          window.location.href = '/pages/thank-you';
          return;
        }

        var email = emailInput ? emailInput.value.trim() : '';
        if (!isValidEmail(email)) {
          showError('Please enter a valid email address.');
          return;
        }
        if (!listId) {
          showError('This form isn\'t connected to a list yet.');
          return;
        }
        if (!KLAVIYO_KEY || KLAVIYO_KEY === 'YOUR_PUBLIC_API_KEY') {
          showError('Signup isn\'t configured yet.');
          return;
        }

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

        var utms = getStoredUTMs();
        var properties = {
          source: 'withvoog-prelaunch',
          form_location: formLocation,
          referrer: document.referrer || ''
        };
        Object.keys(utms).forEach(function (k) { properties[k] = utms[k]; });

        klaviyoSubscribe(email, listId, properties)
          .then(function (res) {
            if (res.ok || res.status === 202) {
              window.location.href = '/pages/thank-you?e=' + encodeURIComponent(email);
            } else {
              throw new Error('subscribe failed');
            }
          })
          .catch(function () {
            showError('Something went wrong — please try again.');
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalBtnText; }
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();
